<template>
  <div class="content">
    <div v-for="(linkset, index) in links" :key="index" class="linkcard">
      <a
        class="link"
        v-for="link in linkset"
        :key="link.key"
        :href="link.link"
        target="_blank"
        >{{ link.key }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        [
          {
            key: "商業．職場",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=528",
          },
          {
            key: "財經．投資",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=516",
          },
          {
            key: "心靈．勵志",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=521",
          },
          {
            key: "人性‧心理",
            link: "	http://site.magv.com/twcit/ListBook.aspx?mcaID=529",
          },
        ],
        [
          {
            key: "名家文學小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=524",
          },
          {
            key: "浪漫愛情小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=525",
          },
          {
            key: "歷史武俠小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=526",
          },
          {
            key: "恐怖驚悚小說",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=527",
          },
        ],
        [
          {
            key: "保健．養生",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=511",
          },
          {
            key: "人物．歷史",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=522",
          },
          {
            key: "命理．宗教",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=519",
          },
          {
            key: "語言．學習",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=513",
          },
        ],
        [
          {
            key: "育兒．教養",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=518",
          },
          {
            key: "兩性．婚姻",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=206",
          },
          {
            key: "瘦身．美容",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=515",
          },
          {
            key: "食譜．手作",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=404",
          },
        ],
        [
          {
            key: "福音‧信仰",
            link: "	http://site.magv.com/twcit/ListBook.aspx?mcaID=530",
          },
          {
            key: "童書．繪本",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=510",
          },
          {
            key: "其他．特刊",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=202",
          },
        ],
        [
          {
            key: "旅遊．飲食",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=520",
          },
          {
            key: "攝影．藝術",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=517",
          },
          {
            key: "科普．生活",
            link: "http://site.magv.com/twcit/ListBook.aspx?mcaID=512",
          },
          {
            key: "空間‧建築",
            link: "	http://site.magv.com/twcit/ListBook.aspx?mcaID=532",
          },
        ],
      ],
    };
  },
};
</script>

<style scoped>
.content {
  height: 100%;
  width: 9.4rem;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
}

.linkcard {
  margin: 0.2rem;
  min-width: 2.26rem;
}

.link {
  display: block;
  border-bottom: 1px solid #474747;
  color: #474747;
  font-size: 0.25rem;
  line-height: 0.55rem;
}

.link:last-child {
  border-bottom: none;
}
</style>